import type { IdGenerator } from '@anytracker/core'

/**
 * The web implementation of core's `IdGenerator` port.
 *
 * `crypto.randomUUID()` is a platform global, which is exactly why core cannot
 * call it and this exists (ADR-0002). The native app supplies its own.
 */
export class CryptoIds implements IdGenerator {
  next(): string {
    return crypto.randomUUID()
  }
}
